import { getUserVisibleOrDefaultExceptionMessage, isUserVisibleException } from '@paragon/client-tools';
import { EstimateInfo } from '@paragon/contract-library';
import { designService } from '@paragon/data-connections';
import { enqueueError } from '@paragon/notification-tools';
import { runWithSpinner } from '@paragon/task-spinner';

import { ThunkActionVoid } from './thunkActions';

export const createEstimatePdf =
  (estimateInfo: EstimateInfo): ThunkActionVoid =>
  async (dispatch, getState) => {
    try {
      const openContext = getState().application.openContext;
      if (openContext?.type === 'project') {
        const fileResult = await dispatch(
          runWithSpinner(
            'Generating Estimate PDF...',
            designService.estimates.postGenerateEstimatePdfForProject(estimateInfo, openContext.projectGuid),
          ),
        );
        fileResult.download();
      } else if (openContext?.type === 'shared-component-set') {
        const fileResult = await dispatch(
          runWithSpinner(
            'Generating Estimate PDF...',
            designService.estimates.postGenerateEstimatePdfForSharedComponentSet(
              estimateInfo,
              openContext.sharedComponentSetLookupCode,
            ),
          ),
        );
        fileResult.download();
      } else {
        dispatch(enqueueError('Cannot generate Estimate PDF outside of project or shared component set context.'));
        return;
      }
    } catch (error) {
      if (isUserVisibleException(error)) {
        dispatch(enqueueError(error.userVisibleMessage));
      } else {
        console.error(error);
        dispatch(onDownloadErrorFor('Estimate PDF', error));
      }
    }
  };

export const createEstimateCsv =
  (estimateInfo: EstimateInfo): ThunkActionVoid =>
  async (dispatch, getState) => {
    try {
      const openContext = getState().application.openContext;
      if (openContext?.type === 'project') {
        const fileResult = await dispatch(
          runWithSpinner(
            'Generating Estimate CSV...',
            designService.estimates.postGenerateEstimateCsvForProject(estimateInfo, openContext.projectGuid),
          ),
        );
        fileResult.download();
      } else if (openContext?.type === 'shared-component-set') {
        const fileResult = await dispatch(
          runWithSpinner(
            'Generating Estimate CSV...',
            designService.estimates.postGenerateEstimateCsvForSharedComponentSet(
              estimateInfo,
              openContext.sharedComponentSetLookupCode,
            ),
          ),
        );
        fileResult.download();
      } else {
        dispatch(enqueueError('Cannot generate Estimate CSV outside of project or shared component set context.'));
        return;
      }
    } catch (error) {
      if (isUserVisibleException(error)) {
        dispatch(enqueueError(error.userVisibleMessage));
      } else {
        console.error(error);
        dispatch(onDownloadErrorFor('Estimate CSV', error));
      }
    }
  };

const onDownloadErrorFor =
  (fileType: string, error: unknown): ThunkActionVoid =>
  (dispatch) => {
    console.error(error);
    dispatch(
      enqueueError(
        getUserVisibleOrDefaultExceptionMessage(
          error,
          `Error downloading ${fileType}.  Please try again or contact Paragon Customer Support`,
        ),
      ),
    );
  };
